import { useSelector } from 'react-redux';
import { buildFcmRequestItem, postFcmServer } from '../Services/Common/fcmApi';

const DEFAULT_CHUNK_SIZE = 100;

const resolveTargetUserIds = ({ targetUserId, targetUserIds }) => {
  if (Array.isArray(targetUserIds) && targetUserIds.length) {
    return [...new Set(targetUserIds.map(String).filter(Boolean))];
  }
  if (targetUserId) return [String(targetUserId)];
  return [];
};

/**
 * FCM 발송 훅 — PostFcmServer 배열 API (단건·다건 통합)
 * @returns {Function} sendFcm — targetUserId(단건) 또는 targetUserIds(다건)
 */
const useFcmHandler = () => {
  const { userInfo } = useSelector((state) => state.BaseInfo);
  const requestUserId = userInfo?.userid ?? '';

  const sendFcm = async ({
    targetUserId,
    targetUserIds,
    title,
    body,
    codeGroup,
    route,
    responseData,
    chunkSize = DEFAULT_CHUNK_SIZE,
  }) => {
    const ids = resolveTargetUserIds({ targetUserId, targetUserIds });
    console.log('[FCM] sendFcm request', {
      targetUserIds: ids,
      title,
      codeGroup,
      route: route ?? '',
      responseData: responseData ?? '',
    });
    if (!ids.length) {
      console.warn('[FCM] 발송 대상자가 없어 요청하지 않음', {
        title,
        codeGroup,
      });
      return;
    }

    const size = Math.max(1, chunkSize);
    for (let i = 0; i < ids.length; i += size) {
      const chunk = ids.slice(i, i + size);
      const payload = chunk.map((id) =>
        buildFcmRequestItem(
          {
            targetUserId: id,
            title,
            body,
            codeGroup,
            route,
            responseData,
          },
          requestUserId
        )
      );
      try {
        const result = await postFcmServer(payload);
        console.log('[FCM] server response', result);
        console.log(
          `✅ FCM 발송: ${chunk.length}명 (${Math.min(i + chunk.length, ids.length)}/${ids.length})`
        );
      } catch (error) {
        console.error('❌ sendFcm chunk error:', error);
      }
    }
  };

  return sendFcm;
};

export default useFcmHandler;
